import signInImage from './Assets/signin-img.webp';
import logo from '../../Assets/Images/logo.svg';
import { SignInForm } from '../../Components/SignInForm/SignInForm';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { useAlert } from '../../contexts/AlertContext';
import { useAuth } from '../../contexts/AuthContext';

export const SignIn = () => {
  const { width } = useWindowDimensions();
  const { showAlert } = useAlert();
  const { login } = useAuth();

  const handleSubmit = async (values: { email: string; password: string }) => {
    try {
      await login(values.email, values.password);
      showAlert('Successfully logged in!', 'success');
    } catch (err: any) {
      showAlert('Invalid email or password.', 'error');
    }
  };

  return (
    <main className="sign-in">
      {width > 768 && <img src={signInImage} alt="abstract background" className="sign-in-image" />}
      <section className="content">
        <img src={logo} alt="logo" className="logo" />
        <h1>Log in to your account</h1>
        <p>Welcome back! Please enter your details.</p>
        <SignInForm onSubmit={handleSubmit} />
      </section>
    </main>
  );
};
